// Translated from https://medium.com/sopra-steria-norge/msal-react-automatically-sign-in-users-and-get-app-roles-30893449ed87
import React from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import axios from 'axios';
import { loginRequest } from './msalConfig';

let lastInterceptor;

const RequestInterceptor = ({ children }) => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);

  /* eslint-disable no-param-reassign */
  const addToken = async (config) => {
    if (!account) {
      throw Error('No active account! Verify a user has been signed in.');
    }

    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    const impersonatedUser = JSON.parse(sessionStorage.getItem('impersonate'));

    if (impersonatedUser) {
      config.headers.ImpersonatedUser = impersonatedUser.userName;
    }

    const bearer = `Bearer ${response.accessToken}`;
    config.headers.Authorization = bearer;

    return config;
  };

  if (!lastInterceptor) {
    lastInterceptor = axios.interceptors.request.use(addToken);
  }

  /* eslint-enable no-param-reassign */

  return <>{children}</>;
};

export default RequestInterceptor;
